// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"Tabs__tabsContainer__3BZzp","myCol":"Tabs__myCol__32Phh","myCol2":"Tabs__myCol2__2BRe6","myCol3":"Tabs__myCol3__1JCQ_"};